module.exports = __webpack_public_path__ + "img/explain_line.8ed46467.svg";